module.exports = __webpack_public_path__ + "static/img/200143.250ae0d8.png";